import { assert } from '@codegrade/utils';
import { buildUrl, getExternalUrl } from '@/utils/typed';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export class SSOProvider {
    id;
    idpMetadataUrl;
    name;
    description;
    logo;
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    constructor(id, idpMetadataUrl, name, description, logo) {
        this.id = id;
        this.idpMetadataUrl = idpMetadataUrl;
        this.name = name;
        this.description = description;
        this.logo = logo;
        Object.freeze(this);
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    static privateloginUrl(id, netloc) {
        return buildUrl(['api', 'sso', 'saml2', 'login', id], {
            host: netloc,
            protocol: 'https:',
        });
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    get loginUrl() {
        return SSOProvider.privateloginUrl(this.id, window.location.host);
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    static loginUrlFromTenant(tenant) {
        assert.AssertionError.assert(tenant.ssoProviderId.isJust());
        return SSOProvider.privateloginUrl(tenant.ssoProviderId.extract(), tenant.netloc);
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    static fromServerData(data) {
        return new SSOProvider(data.id, data.metadataUrl, data.uiInfo.name, data.uiInfo.description, data.uiInfo.logo.extract());
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    get metadataUrl() {
        return buildUrl(['api', 'sso', 'saml2', 'metadata', this.id], {
            baseUrl: getExternalUrl(),
        });
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    get logoUrl() {
        if (this.logo != null) {
            return this.logo.url;
        }
        return buildUrl(['api', 'v1', 'sso_providers', this.id, 'default_logo']);
    }
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function makeSSOProvider(data) {
    return SSOProvider.fromServerData(data);
}
